import { StepCardStatus } from './types.ts';

const SHARED_STYLES = {
  borderRadius: '9px',
  boxShadow: '0 2px 5px -4px rgba(0, 0, 0, 0.20)',
  borderStyle: 'solid',
  background: '#FDFDFD',
};

export const BIG_OUTLINE = {
  ...SHARED_STYLES,
  outlineWidth: '4px',
  outlineStyle: 'solid' as const,
  borderWidth: '2px',
};

export const DEFAULT_OUTLINE = {
  ...SHARED_STYLES,
  borderColor: '#ECECED',
  borderWidth: '1px',
  margin: '1px',
};

const NEUTRAL_INACTIVE_COLORS = {
  background: '#F5F5F5',
  borderColor: '#DADCE0',
};

export function getStepCardStyles(status: StepCardStatus) {
  if (status === 'default') return DEFAULT_OUTLINE;
  if (status === 'warning')
    return { ...BIG_OUTLINE, outlineColor: '#ECECED', borderColor: '#BABABA' };
  if (status === 'blocked')
    return { ...BIG_OUTLINE, outlineColor: '#E7E7E7', borderColor: '#A9A9A9' };
  if (status === 'upstream-skipped')
    return {
      ...DEFAULT_OUTLINE,
      ...NEUTRAL_INACTIVE_COLORS,
      borderStyle: 'dashed',
    };
  if (status === 'error')
    return { ...BIG_OUTLINE, outlineColor: '#FBBABB', borderColor: '#F34F52' };
  if (status === 'partially-completed')
    return { ...BIG_OUTLINE, outlineColor: '#FFEEA3', borderColor: '#FFBF00' };
  if (status === 'active') return { ...DEFAULT_OUTLINE, borderColor: 'var(--velos-brand-blue)' };
  if (status === 'disabled')
    return { ...DEFAULT_OUTLINE, ...NEUTRAL_INACTIVE_COLORS, opacity: 0.72 };
  if (status === 'historical-missing-record')
    return { ...DEFAULT_OUTLINE, ...NEUTRAL_INACTIVE_COLORS, borderStyle: 'dashed' };
  // return { ...BIG_OUTLINE, outlineColor: '#FFE49E', borderColor: '#EFB011' };

  return DEFAULT_OUTLINE;
}
